<mat-form-field class="dynamicForm_alignment" [formGroup]="group">
  <mat-label>{{field.labelName}}</mat-label>
  <input matInput #inputField [formControlName]="field.labelCode" type="text" (keydown.backspace)="clearOnBackSpace(field.labelCode)" (keydown.delete)="clearOnBackSpace(field.labelCode)" autocomplete="off"
    [matAutocomplete]="auto" tabindex="-1" [required]="isRequired" [readonly]="field.disabled" (keyup)="getDoctorsDayDetails($event)" (keydown.tab)="onTabOrEnterPressed(field.labelCode)" (keydown.enter)="onTabOrEnterPressed(field.labelCode)">
    <mat-autocomplete #auto="matAutocomplete"
      tabindex="-1" (optionSelected)="selectionOptionChanged($event)">
      @for (item of id1Dropdown; track item) {
        <mat-option [id]="item.primaryId">{{item.primaryId}}</mat-option>
      }
      @if (isLoading) {
        <mat-option  id="loading">Loading</mat-option>
      }
      @if (noData) {
        <mat-option id="{{noRecord}}">
          No records found.
        </mat-option>
      }
    </mat-autocomplete>
    @if (group.get(field.labelCode).hasError(required)) {
      <mat-error>{{field.labelName}} is mandatory</mat-error>
    }
    @if (field.disabled) {
      <span class="mat-error disabled-error">There are no values in the dropdown</span>
    }
    @for (validation of field.validations; track validation) {
      <ng-container ngProjectAs="mat-error">
        @if (group.get(field.labelCode).hasError(validation.name.toLocaleLowerCase()) && validation.name.toLocaleLowerCase()!==required) {
          <mat-error>{{validation.message}}</mat-error>
        }
        @if (group.get(field.labelCode).hasError(invalid)) {
          <mat-error></mat-error>
        }
      </ng-container>
    }
    @if (group.get(field.labelCode).hasError('invalidAutocompleteObject') && !group.get(field.labelCode).hasError(required)) {
      <mat-error>Please select
      from the given options</mat-error>
    }
  </mat-form-field>

